import React from 'react';
import type { Language } from '../../types/language';
import type { DCStatus } from '../../types/dashboard';
import { pickLang } from '../../types/dashboard';

const LABELS: Record<DCStatus, { en: string; fa: string }> = {
  online: { en: 'ONLINE', fa: 'آنلاین' },
  degraded: { en: 'DEGRADED', fa: 'کاهش‌یافته' },
  offline: { en: 'OFFLINE', fa: 'قطع' },
};

const STYLES: Record<DCStatus, string> = {
  online: 'border-emerald-400/50 bg-emerald-500/15 text-emerald-300',
  degraded: 'border-amber-400/50 bg-amber-500/15 text-amber-200',
  offline: 'border-red-400/50 bg-red-500/15 text-red-200',
};

interface StatusPillProps {
  status: DCStatus;
  language: Language;
  className?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, language, className = '' }) => {
  const t = LABELS[status];
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wide border tabular-nums ${STYLES[status]} ${className}`}
      aria-label={pickLang(language, t.en, t.fa)}
    >
      [{pickLang(language, t.en, t.fa)}]
    </span>
  );
};

/** Network row status from geo-ASN outage score */
export function scoreToNetworkStatus(score: number, eventCnt: number): DCStatus {
  if (score >= 500 || eventCnt > 3) return 'offline';
  if (score > 100 || eventCnt > 0) return 'degraded';
  return 'online';
}
